import { useEffect } from "react";
import { useProfileStore } from "../../../core/store/useProfileStore";

/**
 * `/planos` and a path beneath it. `/planos-extra` does not match.
 * Same cut as the `/planos` prefix in `showsSharedPublicChrome`.
 */
export function isPlanosPath(pathname: string): boolean {
  return pathname === "/planos" || pathname.startsWith("/planos/");
}

/**
 * The only public route that swaps to the logged-in shell.
 * `/contato`, `/termos`, `/privacidade`, `/reembolso`, and the 404 stay
 * on the public frame even when the profile is `free`.
 */
export function isSignedInFreeOnPlanos(
  pathname: string,
  profile: string | null | undefined,
): boolean {
  return profile === "free" && isPlanosPath(pathname);
}

/**
 * Profile both shells read, so they cannot disagree about the swap.
 *
 * The store is seeded from `localStorage`, which decides the first paint.
 * `load()` runs only on `/planos`, and only while the store is still idle,
 * so a visit to `/contato` does not fetch a profile just to keep the
 * public header.
 */
export function usePlanosVisitorProfile(pathname: string): string | null {
  const profile = useProfileStore((state) => state.profile);
  const status = useProfileStore((state) => state.status);
  const load = useProfileStore((state) => state.load);

  useEffect(() => {
    if (!isPlanosPath(pathname)) return;
    if (status === "idle") void load();
  }, [pathname, status, load]);

  return profile;
}
